/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
export default {
    changeVerifyCode,
    clearCurrentClass,
    studentEntryState,
    setSelectedSession,
    updateStudentRecord,
    completeSignup,
    resetState,
    autocompleteAddressStudentPublicStudentUpdate
}

function changeVerifyCode(state, payload){
    state.classCode = payload
}
function clearCurrentClass(state){
    state.classCode = ''
    state.class = null
    state.sessions = null
    state.selectedSession = []
    state.studentEntry = false
    state.signupComplete = false
    state.student = _.cloneDeep(state.initialStudent)
}

function studentEntryState(state, payload){
    state.studentEntry = payload
    if(payload === false){
        state.student = _.cloneDeep(state.initialStudent)
    }
}

function setSelectedSession(state, { id, value, index }){
    console.log(state.selectedSession)
    let hasIDAlready = state.selectedSession.includes(id)
    if(!value && hasIDAlready){
        state.selectedSession = state.selectedSession.filter(x => x != id)
    }
    else if (value && !hasIDAlready){
        state.selectedSession.push(id)
    }
}

function updateStudentRecord(state,{field, value}){
    state.student[field] = value
}

function completeSignup(state){
    state.signupComplete = true
}

function resetState (state) {
    // _.each(state, (value, key) => {
    //     state[key] = initialState[key]
    // })
    
    state = { ...initialState }
}

function autocompleteAddressStudentPublicStudentUpdate(state, { place, stateOptions }){
    // Assign Address values
    let a = place.address_components
    console.log(a)
    state.student.address1 = `${addrPart('street_number',a).long_name || ''} ${addrPart('route',a).long_name || ''}`
    state.student.city = `${addrPart('locality',a).long_name || addrPart('sublocality',a).long_name || ''}`
    state.student.county = `${addrPart('administrative_area_level_2',a).long_name.replace(" County","") || ''}`
    state.student.zip = `${addrPart('postal_code',a).short_name || ''}`
    
    let foundState = _.find(stateOptions,{label: addrPart('administrative_area_level_1',a).short_name.toUpperCase()})
    if(foundState && foundState.value){
        state.student.state = foundState.value
    }
}

// Part part of an address based on the type
function addrPart(type,address){
    return _.find(address,{types:[type]}) || {long_name:null,short_name:null}
}